import React from 'react';
import { useOffline } from '../../offline/OfflineContext';
import OfflinePanel from './OfflinePanel';

/**
 * Single mount point for the offline panel.
 *
 * Both entry points (navbar and dashboard strip) just call `openPanel()` on
 * the context; neither owns the modal. That keeps one instance of the
 * preparation flow alive regardless of which screen the user is on — which
 * matters because preparing a pack takes a while and navigating mid-build
 * must not tear it down.
 */
const OfflinePanelHost = () => {
  const { panelOpen, closePanel } = useOffline();
  return <OfflinePanel open={panelOpen} onClose={closePanel} />;
};

export default OfflinePanelHost;
